window.waveFunc = {
    showPatientForm: (patient_id, form_id) => {
        let xhr = new XMLHttpRequest();
        let body = '_token=' + csrf_token + '&form_id=' + form_id + '&patient_id=' + patient_id;
        xhr.open('POST', `/patient/form`, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function () {
            if (xhr.readyState === xhr.DONE) {
                if (xhr.status === 200) {
                    const domParser = new DOMParser();
                    const formHTML = domParser.parseFromString(xhr.response, 'text/html');
                    let form = formHTML.getElementById('patient_form');
                    document.body.appendChild(form);
                    document.getElementById('modal').appendChild(form);
                    waveFunc.customizeFileInputs();
                    waveFunc.onePageForm();
                }
            }
        };
        xhr.send(body);
    },
    showProfileForm: () => {
        let xhr = new XMLHttpRequest();
        let body = '_token=' + csrf_token;
        xhr.open('POST', `/profile`, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function () {
            if (xhr.readyState === xhr.DONE) {
                if (xhr.status === 200) {
                    const domParser = new DOMParser();
                    const formHTML = domParser.parseFromString(xhr.response, 'text/html');
                    let form = formHTML.getElementById('profile_update_form');
                    document.body.appendChild(form);
                    let modal = document.getElementById('modal')
                    modal.appendChild(form);
                    modal.querySelector('#default_profile_open').click();
                    waveFunc.onePageForm();
                }
            }
        };
        xhr.send(body);
    },
    showHeaderDropdown: (targetDropdown, targetButton) => {
        let dropdown = document.getElementById(targetDropdown);
        let clientInfoButton = document.getElementById(targetButton);

        let listener = function (event) {
            if (!dropdown.contains(event.target) && !clientInfoButton.contains(event.target)) {
                dropdown.classList.remove('active');
                document.removeEventListener('click', listener, false);
            }
        };
        dropdown.classList.toggle('active')

        document.addEventListener('click', listener, false);
    },
    savePatientForm: (patient_id, form_goal) => {
        let form = document.getElementById('patient_main_form');
        let body = new FormData(form);
        let xhr = new XMLHttpRequest();

        xhr.open('POST', `/patient/save/${patient_id}`, false);
        xhr.onload = function () {
            if (xhr.readyState === xhr.DONE) {
                if (xhr.status === 200) {
                    console.log('done')
                }
            } else {
                console.log('error')
            }
        };
        xhr.send(body);
    },
    getSiblings: (elem) => {
        let siblings = [];
        let sibling = elem.parentNode.firstChild;

        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== elem) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }

        return siblings;
    },
    disableSelectOptions: (_this) => {
        let parent = _this.parentNode;
        let siblings = waveFunc.getSiblings(parent);
        parent.querySelectorAll('div.wave-line-radiobutton-label-inner *:not(option)').forEach(function (a) {
            a.disabled = a.disabled ? false : true;
        });

        siblings.forEach(sibling => {
            sibling.querySelectorAll('div.wave-line-radiobutton-label-inner *:not(option)').forEach(function (a) {
                a.disabled = true;
            });
        });

    },
    openTab: (evt, tabName, parent_id) => {
        let parent = document.getElementById(parent_id);
        let i, tabcontent, tablinks;
        tabcontent = parent.getElementsByClassName('tabcontent');
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = 'none';
        }
        tablinks = parent.getElementsByClassName('tablinks');
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(' active', '');
        }
        parent.querySelector('#' + tabName).style.display = 'block';
        evt.currentTarget.classList.add('visited', 'active');
    },
    openStepFormTab: (buttonId) => {
        document.getElementById(buttonId).click();
    },
    changeSelectButtonClass: (evt) => {
        let parent = evt.target.parentNode;
        let teethCheckbox = document.getElementById('teeth_checkbox');
        let _this = evt.target;
        let siblings = waveFunc.getSiblings(parent);
        parent.click();
        _this.classList.add('orange-button');
        siblings.forEach(sibling => {
            let button = sibling.querySelector('button');
            if(button) {
                button.classList.remove('orange-button');
            }
        });
        teethCheckbox.classList.remove('disabled')
    },
    onePageForm: () => {
        let form;

        function findElements() {
            form = document.querySelector('#modal-wrap form');
        }

        function showMessage(data) {
            form.parentNode.innerHTML = `
                <div class="wave-line-modal__result">
                    <h1 class="wave-line-modal__result-text"> ${data.message} </h1>
                    <svg>
                        <use xlink:href="#check_ring-icon"></use>
                    </svg>
                </div>`;
        }

        function onSuccess(data) {
            showMessage(data);
        }

        function onError(data) {
            console.error(data);
        }

        function collectData(currentForm) {
            return new FormData(currentForm);
        }

        function setOptions(currentForm) {
            return {
                method: 'post',
                body: collectData(currentForm),
            };
        }

        function sendForm(currentForm) {
            return fetch(currentForm.action, setOptions(currentForm));
        }

        function onSubmit(event) {
            event.preventDefault();
            const {currentTarget} = event;
            sendForm(currentTarget)
                .then(response => response.json())
                .then(data => onSuccess(data, currentTarget))
                .catch(onError);
        }

        function subscribe() {
            form.addEventListener('submit', onSubmit);
        }

        function init() {
            findElements();
            subscribe();
        }

        init();
    },
    customizeFileInputs: () => {
        let inputs = document.querySelectorAll('.wave-line-inputfile');

        if (inputs) {
            inputs.forEach(function (input) {
                let label = input.nextElementSibling;
                let labelVal = label.querySelector('span').innerHTML;


                input.addEventListener('change', function (e) {
                    let fileName = '';
                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        label.querySelector('span').innerHTML = fileName;
                    else
                        label.innerHTML = labelVal;
                });
            });
        }
    },
    loadSnapshot: (event) => {
        let reader = new FileReader();
        reader.onload = function(){
            let output = event.srcElement.parentNode.querySelector('img');
            output.src = reader.result;
        };
        reader.readAsDataURL(event.target.files[0]);
    },
    closeModal: () => {
        document.getElementById('close-modal').click();
    },
    toothCheck: () => {
        let teeth = document.querySelectorAll('.teeth-checkbox-label-wrap')
        teeth.forEach(tooth => {
            tooth.addEventListener('click', function(e)  {
                let currentRadio = document.querySelector('input[name="peculiar_properties"]:checked').id;
                let input = tooth.querySelector('input[type="hidden"]');
                if(input.value.includes(currentRadio + '[cut]')) {
                    let currentInputValue = input.value
                    input.value = currentInputValue.replace(currentRadio + '[cut]', '');
                    tooth.classList.remove(currentRadio);
                } else {
                    input.value += currentRadio + '[cut]';
                    tooth.classList.add(currentRadio)
                }
            })
        })
    }
};
